import { PaymentsFlowEntryPoint } from '../use-payment-flow';

const validPaymentsFlowEntryPoints: readonly PaymentsFlowEntryPoint[] = [
  'BILL_PAY_UPLOAD_INVOICE',
  'VIEW_ALL_BENEFICIARIES',
  'INVOICE_PAGE',
];

export const isPaymentsFlowEntryPoint = (value: string | null): value is PaymentsFlowEntryPoint => {
  if (value === null) {
    return false;
  }

  return validPaymentsFlowEntryPoints.includes(value as PaymentsFlowEntryPoint);
};
